// removed by extract-text-webpack-plugin
module.exports = {"addon":"AddonItem_addon---sb","remove-btn":"AddonItem_remove-btn---sb","removeBtn":"AddonItem_remove-btn---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Rooms/Room/RoomBody/AddonsList/AddonItem/styles.less
// module id = 1639
// module chunks = 0